/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const DocumentToSubmitType = {
    CoverSheet: 'cover_sheet',
    Hp: 'hp',
    MedList: 'med_list',
    PtEval: 'pt_eval',
    PtNote: 'pt_note',
    OtEval: 'ot_eval',
    OtNote: 'ot_note',
    SlpEval: 'slp_eval',
    SlpNote: 'slp_note',
    MdNote: 'md_note',
    Facesheet: 'facesheet',
    Other: 'other'
} as const;
export type DocumentToSubmitType = typeof DocumentToSubmitType[keyof typeof DocumentToSubmitType];


export function DocumentToSubmitTypeFromJSON(json: any): DocumentToSubmitType {
    return DocumentToSubmitTypeFromJSONTyped(json, false);
}

export function DocumentToSubmitTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentToSubmitType {
    return json as DocumentToSubmitType;
}

export function DocumentToSubmitTypeToJSON(value?: DocumentToSubmitType | null): any {
    return value as any;
}

